<!-- Camera -->
<div class="camera-bar" gaCategory="Engine 3D Controls" data-test="cameraBar">
  <app-pillbox
    eventCategory="Engine 3D Controls"
    orientation="vertical"
    *ngIf="showNav">
    <div class="camera-bar__nav">
      <!-- Zoom Out -->
      <button 
        gaEvent
        gaAction="Clicked Zoom Out"
        app-pin-button
        *ngIf="showZoom"
        buttonType="ghost"
        icon="minus"
        tabIndex="0"
        data-test="cameraZoomOut"
        (touchstart)="setZoom('out')"
        (mousedown)="setZoom('out')"
        (touchend)="setZoom('')"
        (mouseup)="setZoom('')"
        (mouseleave)="setZoom('')"
        (keyup.enter)="setZoomFixed('out')"
        aria-label="Zoom Out"
        matTooltip="Zoom Out"
        matTooltipPosition="left">
      </button>

      <!-- Zoom In -->
      <button 
        gaEvent
        gaAction="Clicked Zoom In"
        app-pin-button
        *ngIf="showZoom"
        buttonType="ghost"
        icon="plus"
        tabIndex="0"
        data-test="cameraZoomIn"
        (touchstart)="setZoom('in')"
        (mousedown)="setZoom('in')"
        (touchend)="setZoom('')"
        (mouseup)="setZoom('')"
        (mouseleave)="setZoom('')"
        (keyup.enter)="setZoomFixed('in')"
        aria-label="Zoom In"
        matTooltip="Zoom In"
        matTooltipPosition="left">
      </button>

      <!-- Return to chapter position -->
      <button 
        gaEvent
        gaAction="Clicked Recenter 3D Model"
        app-pin-button
        *ngIf="showResetPosition"
        icon="location"
        buttonType="ghost"
        tabIndex="0"
        (click)="returnToChapterCamera()"
        aria-label="Recenter 3D model"
        matTooltip="Recenter 3D model"
        matTooltipPosition="left"
        data-test="cameraReset">
      </button>

      <!-- Pan Mode -->
      <button 
        gaEvent
        gaAction="Clicked Switch Mode"
        [gaLabel]="(panMode$ | async) === 'pan' ? 'Rotate' : 'Pan'"
        app-pin-button
        [selected]="(panMode$ | async) === 'pan'"
        tabIndex="0"
        *ngIf="showPan"
        icon="arrows-alt"
        buttonType="ghost"
        (click)="togglePan()"
        [attr.aria-label]="(panMode$ | async) === 'pan' ? 'Switch to Rotate Mode' : 'Switch to Pan Mode'"
        [matTooltip]="(panMode$ | async) === 'pan' ? 'Switch to Rotate Mode' : 'Switch to Pan Mode'"
        matTooltipPosition="left"
        data-test="cameraPan">
      </button>
      
    </div>
  </app-pillbox>  
</div>